<template>
  <v-card class="pa-6">
    <v-card-text>
      <p class="mb-0">
        Delete denied. A default bookmark is required.
      </p>
    </v-card-text>

    <v-card-actions class="justify-center">
      <v-btn
        color="primary"
        outlined
        @click.stop="cancelDeleteBookmark"
      >
        OK
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import BookmarkMixin from 'src/tools/store/utils/bookmarks-mixin'

export default {
  name: 'BookmarkDeny',
  mixins: [
    BookmarkMixin,
  ],
}
</script>
